import CreatorMessageAcceptMediaModalComponent from "./CreatorMessageAcceptMediaModalComponent";

export default CreatorMessageAcceptMediaModalComponent